var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.35826 0 0 3.35826 0 7.5C0 11.6417 3.35826 15 7.5 15C11.6417 15 15 11.6417 15 7.5C15 3.35826 11.6417 0 7.5 0ZM7.5 13.7277C4.06138 13.7277 1.27232 10.9386 1.27232 7.5C1.27232 4.06138 4.06138 1.27232 7.5 1.27232C10.9386 1.27232 13.7277 4.06138 13.7277 7.5C13.7277 10.9386 10.9386 13.7277 7.5 13.7277Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69629 4.55357C6.69629 4.76669 6.78095 4.97108 6.93165 5.12178C7.08235 5.27248 7.28674 5.35714 7.49986 5.35714C7.71298 5.35714 7.91737 5.27248 8.06807 5.12178C8.21877 4.97108 8.30343 4.76669 8.30343 4.55357C8.30343 4.34045 8.21877 4.13606 8.06807 3.98536C7.91737 3.83466 7.71298 3.75 7.49986 3.75C7.28674 3.75 7.08235 3.83466 6.93165 3.98536C6.78095 4.13606 6.69629 4.34045 6.69629 4.55357ZM7.90165 6.42857H7.09807C7.02441 6.42857 6.96415 6.48884 6.96415 6.5625V11.1161C6.96415 11.1897 7.02441 11.25 7.09807 11.25H7.90165C7.97531 11.25 8.03557 11.1897 8.03557 11.1161V6.5625C8.03557 6.48884 7.97531 6.42857 7.90165 6.42857Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d40681214ee211c6b04dbc9613ef2f61.svg";
export { ForwardRef as ReactComponent };